import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=71fbd521&scoped=true&"
import script from "./logList.vue?vue&type=script&lang=js&"
export * from "./logList.vue?vue&type=script&lang=js&"
import style0 from "./logList.vue?vue&type=style&index=0&id=71fbd521&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fbd521",
  null
  
)

export default component.exports